// Shared layout for frames 20 (checkout success) and 21 (checkout
// cancelled) — both are one centred 520px card: icon, headline, body copy,
// actions. Figma's "authshell" node, ported as a plain div rather than a
// new src/ui/ primitive since only these two screens use it.

import "./commerce.css";
import type { IconName } from "../../ui/Icon";
import { Icon } from "../../ui/Icon";
import type { ReactNode } from "react";

export type CheckoutReturnPanelProps = {
  icon: IconName;
  iconTone: "nominal" | "neutral";
  title: string;
  body: ReactNode;
  actions: ReactNode;
  children?: ReactNode;
};

export function CheckoutReturnPanel({
  icon,
  iconTone,
  title,
  body,
  actions,
  children,
}: CheckoutReturnPanelProps) {
  return (
    <div className="maisight-commerce-return">
      <div className="maisight-commerce-return-panel">
        <span className="maisight-commerce-return-icon" data-tone={iconTone}>
          <Icon name={icon} size={20} />
        </span>
        <h1 className="maisight-commerce-return-title type-h2">{title}</h1>
        <p className="maisight-commerce-return-body type-bodyS">{body}</p>
        {children}
        <div className="maisight-commerce-return-actions">{actions}</div>
      </div>
    </div>
  );
}
